import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles((theme) => ({
  modal: {
    maxWidth: "730px",
  },
  section: {
    width: "100%",
    marginTop: 40,
  },
  buttonSettings: {
    whiteSpace: "nowrap",
    width: 90,
    height: 40,
  },
  buttonsShareLink: {
    whiteSpace: "nowrap",
    width: 126,
    height: 40,
  },
  customerName: {
    marginBottom: 8,
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: 18,
    lineHeight: "18px",
    color: "#465869",
  },
  taskStartDate: {
    color: "#465869",
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: 16,
    lineHeight: "18px",
  },
  videoSection: {
    marginTop: 24,
    width: "100%",
  },
  noCameraAvailable: {
    height: "30vh",
    backgroundColor: "#EDF5FB",
    borderRadius: 12,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    "& .cameraOff": {
      fontFamily: "Manrope",
      fontWeight: 700,
      fontSize: 12,
      lineHeight: "16px",
      color: "#667085",
    },
  },
  cameraAvailable: {
    height: "30vh",
    marginBottom: 16,
  },
  options: {
    display: "flex",
    gap: 25,
    paddingTop: 24,
  },
  option: {
    display: "flex",
    alignItems: "center",
    "& span": {
      color: "#465869",
      font: "500 16px/18px Manrope",
    },
  },
  headerIcon: {
    backgroundColor: "#308CDB4D",
    height: 40,
    width: 40,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 16,
  },
  sharingTitle: {
    display: "flex",
    alignItems: "center",
    marginBottom: 16,
  },
}));

export default styles;
